<!--  -->
<template>
  <div class="head-nav sticky">
    <div class="logo-box">
      <a href="/" class="logo" title="测评系统"><img :src="`/static/img/logo.png?t=${Math.random()}`" alt="logo"></a>
    </div>
    <nav class="main-menu">
      <ul>
        <li>
          <router-link to="/">首&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;页</router-link>
        </li>
        <li>
          <router-link :to="'/listView/'+plateTest">考评服务</router-link>
        </li>
        <li>
          <router-link :to="'/listView/'+platePer">人才测评</router-link>
        </li>
        <li>
          <router-link :to="'/listView/'+plateStu">咨询研究</router-link>
        </li>
        <li>
          <router-link :to="'/news/info/'+articleUs+'/000000'">关于我们</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      plates:[],
      plateTest: "",
      platePer: "",
      plateStu: "",
      articleUs:""
    }
  },
  mounted() {
    this.$axios
      .get("/api/categorys?page=1&limit=30&firstView=1")
      .then((res) => {
        if (res.data) {
          this.plates = res.data.data;
          for (var i = 0; i < this.plates.length; i++) {
            if (this.plates[i].name == "考评服务") {
              this.plateTest = this.plates[i]._id;
            }
            if (this.plates[i].name == "人才测评") {
              this.platePer = this.plates[i]._id;
            }
            if (this.plates[i].name == "咨询研究") {
              this.plateStu = this.plates[i]._id;
            }
            if (this.plates[i].name == "关于我们") {
              this.articleUs = this.plates[i]._id;
            }
          }
        }
      });
    
  }
};
</script>
<style scoped>
.main-menu{
  right: 408px;
}
.head-nav{
  position: sticky;
  top:0;
  width: 100%;
  height: 88px;
  z-index: 99999;
  background-color:#ffffff;
}
.head-nav .logo-box{
  position: relative;
  width: 1200px;
  height: 88px;
  margin: 0 auto;
  display: flex;
  justify-content: start;
}
.logo-box .logo img {
  margin-top: 18px;
margin-bottom: 20px;
margin-left: 1px;
}
.main-menu li {
  cursor:pointer;
  margin-left: 40px;
}
.main-menu li:hover a{
    color: #4462CF;
}
</style>
